export const passwordMinLengthValidation = (password?: string, minLength = 6): string | boolean => {
  if (password === '' || !password) return true;
  if (password.length >= minLength) return true;
  return false;
};
